import React, { Component } from 'react';
import Aux from '../../hoc/Auxilary';
import Burger from '../../components/Burger/Burger';
import BuildControls from '../../components/Burger/BuildControls/BuildControls';
import Modal from '../../components/UI/Modal/Modal';
import OrderSummary from '../../components/Burger/OrderSummary/OrderSummary';
import Spinner from '../../components/UI/Spinner/Spinner';
import withErrorHandler from '../../hoc/WithErrorHandler/WithErrorHandler';
import axios from '../../axios-orders';
import * as actionTypes from '../../store/actions/actionTypes';
import {connect} from 'react-redux';
import * as action from '../../store/actions/index';

class BurgerBuilder extends Component {

    // constructor(props) {
    //     super(props);
    //     this.state = ...
    // }

    state = {
        // if not using db
        // ingredients: {
        //     salad: 0,
        //     bacon: 0,
        //     cheese: 0,
        //     meat: 0
        // },

        // if using db
        // ingredients: null,  // moved to redux
        // totalPrice: 4,      // moved to redux
        // isPurchasable: false,  // can be moved to redux but currently handled locally
        purchasing: false,


        // loading: false,
        // error: false        // moved to redux
    }

    purchasingHandler = () => {
        
        if(this.props.isAuthenticated) {
            this.setState({
                purchasing: true
            });
        } else {
            this.props.onSetAuthRedirectPath('/checkout')
            this.props.history.push('/auth');
        }
    }

    componentDidMount() {
        // direct component loaded by Route will be having props with 
        // loacation, history, match
        //console.log(this.props);

        // axios.get('https://react-burger-builder-d26ba.firebaseio.com/ingredients.json')
        //     .then(response => {
        //         this.setState({
        //             ingredients: response.data
        //         });
        //     })
        //     .catch(error => {
        //         this.setState({
        //             error: true
        //         })
        //     });

        // calling through async thunk action creator and with reducer
        this.props.onInitIngredients();
    }

    updatePurchaseSate(ingredients) {

        const sum = Object.keys(ingredients)
            .map(iKey => {
                return ingredients[iKey]
            }).reduce((prev, curr) => {
                return prev + curr;
            }, 0);
        return sum > 0;
    }

    // don't need as it is now handled in redux
    // addIngredientHandler = (type) => {
    //     const previousCount = this.state.ingredients[type];
    //     const updatedCount = previousCount + 1;
    //     const updatedIngredients = {
    //         ...this.state.ingredients
    //     }
    //     updatedIngredients[type] = updatedCount;
    //     const priceToBeAdded = INGREDIENTS_PRICE[type];
    //     const previouPrice = this.state.totalPrice;
    //     const updatedTotalPrice = priceToBeAdded + previouPrice;
    //     this.setState(
    //         {
    //             ingredients: updatedIngredients,
    //             totalPrice: updatedTotalPrice
    //         }
    //     )
    //     this.updatePurchaseSate(updatedIngredients);
    // }

    // don't need as it is now handled in redux
    // removeIngredientHandler = (type) => {
    //     const previousCount = this.state.ingredients[type];
    //     if (previousCount <= 0) {
    //         return;
    //     }
    //     const updatedCount = previousCount - 1;
    //     const updatedIngredients = {
    //         ...this.state.ingredients
    //     }
    //     updatedIngredients[type] = updatedCount;
    //     const priceToBeDeducted = INGREDIENTS_PRICE[type];
    //     const previouPrice = this.state.totalPrice;
    //     const updatedTotalPrice = previouPrice - priceToBeDeducted;
    //     this.setState(
    //         {
    //             ingredients: updatedIngredients,
    //             totalPrice: updatedTotalPrice
    //         }
    //     )
    //     this.updatePurchaseSate(updatedIngredients);
    // }

    purchasedCancelHandler = () => {
        this.setState({
            purchasing: false
        });
    }

    purchasedContinueHandler = () => {
        // alert('You can continue with the order!!!');
        
        // now handling through redux
        // const paramsQuery = [];
        // for (let i in this.state.ingredients) {
        //     paramsQuery.push(encodeURIComponent(i) + '=' + encodeURIComponent(this.state.ingredients[i]));
        // }
        // paramsQuery.push('price=' + this.state.totalPrice);
        // const queryString = paramsQuery.join('&');

        // // passing ingredients as queryString
        // this.props.history.push({
        //     pathname: '/checkout',
        //     search: '?' + queryString
        // });
        
        this.props.onInitPurchase();
        this.props.history.push('/checkout');
    }

    render() {
        const disabledInfo = {
            ...this.props.ingds
        };

        // this will give {salad: true, meat: false} when the count is less than 0
        for (let key in disabledInfo) {
            disabledInfo[key] = disabledInfo[key] <= 0;
        }

        let burger = this.props.error ? <div style={{textAlign: 'center'}}>
                                            <p>Problem in loading ingredients</p>
                                            <p>Please try after some time!!!</p>
                                        </div> : <Spinner />;
        let orderSummary = null;

        if (this.props.ingds) {
            burger = (  <Aux>
                            <div>
                                <Burger ingredients={this.props.ingds}></Burger>
                            </div>
                            <div>
                                <BuildControls
                                    ingredientsAdded={this.props.onIngredientAdd}
                                    ingredientsRemoved={this.props.onIngredientRemove}
                                    disabled={disabledInfo}
                                    price={this.props.totalPrice}
                                    purchasable={this.updatePurchaseSate(this.props.ingds)}
                                    isAuthenticated={this.props.isAuthenticated}
                                    ordered={this.purchasingHandler} />
                            </div>
                        </Aux>);            

            orderSummary = <OrderSummary
                                ingredients={this.props.ingds}
                                purchaseCancelled={this.purchasedCancelHandler}
                                purchaseContinued={this.purchasedContinueHandler}
                                price={this.props.totalPrice} />                        
        }

        // if (this.state.loading) {
        //     orderSummary = <Spinner />
        // }

        return (
            <Aux>
                <Modal show={this.state.purchasing} modalClosed={this.purchasedCancelHandler}>
                    {orderSummary}
                </Modal>
                {burger}
            </Aux>
        );
    }
}

const mapStateToProps = state => {
    return {
        ingds: state.burgerBuilder.ingredients,
        totalPrice: state.burgerBuilder.totalPrice,
        error: state.burgerBuilder.error,
        isAuthenticated: state.auth.token !== null
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onIngredientAdd: (ingName) => dispatch(action.addIngredient(ingName)),

        onIngredientRemove: (ingName) => dispatch(action.removeIngredient(ingName)),
        
        onInitIngredients: () => dispatch(action.initIngridients()),

        onInitPurchase: () => dispatch (action.purchaseInit()),

        onSetAuthRedirectPath: (path) => dispatch(action.setAuthenticationPath(path))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(BurgerBuilder, axios)); 